<template>
  <div class="container">
    <div class="main">
      <div class="title">热招岗位</div>
      <div class="details">
        <!-- 部分开发岗位 -->
        <div class="post">部分开发岗位</div>
        <ul v-for="(item, index) in partialDevelops" :key="index + 'part'">
          <li class="plus-box" @click="showPartialDevelopsDetails(index)" v-show="idx !== index">
            <span class="job-name">{{ item.job }}</span>
            <img class="plus" src="~assets/img/joinus/plus.png" alt="" />
          </li>
          <li class="subtraction-box" v-show="idx === index">
            <div class="box" @click="foldPartialDevelopsDetails">
              <span class="job-name bold">{{ item.job }}</span>
              <img class="subtraction" src="~assets/img/joinus/Subtraction.png" alt="" />
            </div>
            <div class="line"></div>
            <div class="requirements">
              <p class="jobresponsibility">岗位职责</p>
              <p v-for="(part, index) in item.jobresponsibility" :key="index + 'res'">{{ part }}</p>
              <p class="representationrequirements">任职要求</p>
              <p v-for="(part, index) in item.representationrequirements" :key="index + 'rep'">{{ part }}</p>
              <p class="bonus" v-show="item.bonus">加分项</p>
              <p v-for="(part, index) in item.bonus" :key="index + 'bonus'">{{ part }}</p>
            </div>
          </li>
        </ul>
        <!-- 后端开发岗位 -->
        <div class="post">后端开发岗位</div>
        <ul v-for="(item, index) in backendDevelops" :key="index + 'back'">
          <li class="plus-box" @click="showBackendDevelopsDetails(index)" v-show="imx !== index">
            <span class="job-name">{{ item.job }}</span>
            <img class="plus" src="~assets/img/joinus/plus.png" alt="" />
          </li>
          <li class="subtraction-box" v-show="imx === index">
            <div class="box" @click="foldBackendDevelopsDetails">
              <span class="job-name bold">{{ item.job }}</span>
              <img class="subtraction" src="~assets/img/joinus/Subtraction.png" alt="" />
            </div>
            <div class="line"></div>
            <div class="requirements">
              <p class="jobresponsibility">岗位职责</p>
              <p v-for="(part, index) in item.jobresponsibility" :key="index + 'res'">{{ part }}</p>
              <p class="representationrequirements">任职要求</p>
              <p v-for="(part, index) in item.representationrequirements" :key="index + 'rep'">{{ part }}</p>
              <p class="bonus" v-show="item.bonus">加分项</p>
              <p v-for="(part, index) in item.bonus" :key="index + 'bonus'">{{ part }}</p>
            </div>
          </li>
        </ul>
        <!-- 测试/技术支持岗 -->
        <div class="post">测试/技术支持岗</div>
        <ul v-for="(item, index) in testDevelops" :key="index + 'test'">
          <li class="plus-box" @click="showTestDevelopsDetails(index)" v-show="itx !== index">
            <span class="job-name">{{ item.job }}</span>
            <img class="plus" src="~assets/img/joinus/plus.png" alt="" />
          </li>
          <li class="subtraction-box" v-show="itx === index">
            <div class="box" @click="foldTestDevelopsDetails">
              <span class="job-name bold">{{ item.job }}</span>
              <img class="subtraction" src="~assets/img/joinus/Subtraction.png" alt="" />
            </div>
            <div class="line"></div>
            <div class="requirements">
              <p class="jobresponsibility">岗位职责</p>
              <p v-for="(part, index) in item.jobresponsibility" :key="index + 'res'">{{ part }}</p>
              <p class="representationrequirements">任职要求</p>
              <p v-for="(part, index) in item.representationrequirements" :key="index + 'rep'">{{ part }}</p>
              <p class="bonus" v-show="item.bonus">加分项</p>
              <p v-for="(part, index) in item.bonus" :key="index + 'bonus'">{{ part }}</p>
            </div>
          </li>
        </ul>
        <!-- 销售岗  -->
        <div class="post">销售岗</div>
        <ul v-for="(item, index) in salePosts" :key="index + 'sale'">
          <li class="plus-box" @click="showSalePostDetails(index)" v-show="isx !== index">
            <span class="job-name">{{ item.job }}</span>
            <img class="plus" src="~assets/img/joinus/plus.png" alt="" />
          </li>
          <li class="subtraction-box" v-show="isx === index">
            <div class="box" @click="foldSalePostDetails">
              <span class="job-name bold">{{ item.job }}</span>
              <img class="subtraction" src="~assets/img/joinus/Subtraction.png" alt="" />
            </div>
            <div class="line"></div>
            <div class="requirements">
              <p class="jobresponsibility">岗位职责</p>
              <p v-for="(part, index) in item.jobresponsibility" :key="index + 'res'">{{ part }}</p>
              <p class="representationrequirements">任职要求</p>
              <p v-for="(part, index) in item.representationrequirements" :key="index + 'rep'">{{ part }}</p>
              <p class="bonus" v-show="item.bonus">加分项</p>
              <p v-for="(part, index) in item.bonus" :key="index + 'bonus'">{{ part }}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "HotJobs",
    data() {
      return {
        idx: undefined,
        imx: undefined,
        itx: undefined,
        isx: undefined,
        partialDevelops: [
          {
            job: "WebRTC开发工程师",
            jobresponsibility: [
              "1.负责webrtc媒体服务器js客户端SDK的设计、开发和维护；",
              "2.编写SDK说明文档和sample程序；",
              "3.与媒体服务器后端开发团队协作，进行前后端信令协议的定义；",
              "4.与web前端和微信小程序前端开发团队协作，提供满足应用场景的js SDK；",
              "5.交付高质量的代码；",
              "6.持续学习新的技术，持续提高软件设计能力。",
            ],
            representationrequirements: [
              "1.重点大学计算机相关专业本科以上学历，为人正直，好合作；",
              "2.1年以上webRTC前端开发工作，了解webRTC技术标准的发展趋势；",
              "3.熟悉Chromium开源项目代码，特别是webRTC API部分；",
              "4.有良好的软件设计意识，持续学习软件复杂性管理的各种方法；",
              "5.熟悉web前端各种开发框架，有web前端应用开发经验；",
              "6.善于学习，乐于钻研，自我驱动。",
            ],
            bonus: ["1.有C++实际大型项目开发经验者优先；", "2.有视频直播系统开发经验者优先。"],
          },
          {
            job: "高级Web前端开发工程师",
            jobresponsibility: [
              "1.负责产品Web前端和微信小程序前端的功能设计和实现；",
              "2.根据实际需求，穷举不同的使用场景，并能将需求转化为技术实现路径；",
              "3.与前端js SDK端对和后端团队协作，参与定义前后端通信接口和前端js SDK的API；",
              "4.与产品和UI/UX团队配合，进行快速迭代的产品研发；",
              "5.Web前端和微信小程序前端产品的维护、升级、bug修复；",
              "6.参与需求调研、项目可行性分析、技术可行性分析和需求分析；",
              "7.参与对业务领域内的技术发展动态进行分析研究。",
            ],
            representationrequirements: [
              "1.5年及以上web前端开发工作经验；",
              "2.熟练掌握html/html5、js、xml、javascript、css/css3、ajax、json等前端开发技术，熟悉Angular、vue、react等框架；",
              "3.对各个主流浏览器的前端开发有深刻的理解，有独立开发较大规模前端组件系统的实际经验；",
              "4.具备良好的沟通能力，能够快速了解客户需求，配合团队协作开发，拥有高度的责任感；",
              "5.对web前端技术有强烈兴趣，能对web前沿技术研究和新技术调研；",
              "6.思路清晰，善于思考，较好的逻辑分析能力，做事严谨，能独立分析和解决问题；",
              "7.善于学习，乐于钻研，自我驱动。",
            ],
            bonus: ["1.熟悉webRTC的API，有实时音视频实际产品开发经验者优先；", "2.熟悉OWT js SDK者优先。"],
          },
          {
            job: "安卓开发工程师",
            jobresponsibility: [
              "1.安卓客户端界面及应用程序设计、开发",
              "2.根据产品功能需求设计并完成软件实现",
              "3.能按照项目计划，按时提交高质量的代码，完成开发任务",
              "4.改进用户体验。",
            ],
            representationrequirements: [
              "1.重点大学计算机相关专业本科以上学历，熟悉安卓架构和原理， 3年以上安卓开发工作经验；",
              "2.熟练使用Android SDK Java开发语言、Android Studio等开发工具；",
              "3.熟悉安卓Pad/安卓手机开发技术，包括UI、多线程、Socket网络通信等方面；",
              "4.了解安卓各个版本的特点、机型的适配和UI布局优化等；",
              "5.有良好的团队合作及抗压能力，工作积极主动，责任心强，乐于解决具有挑战性的问题。",
            ],
            bonus: ["1.有webRTC或SIP实际项目经验者优先；", "2.有终端多媒体系统效果调试优化经验者优先。"],
          },
        ],
        backendDevelops: [
          {
            job: "资深后端开发工程师",
            jobresponsibility: [
              "1.深度参与媒体服务器后端系统开发；",
              "2.与产品经理和客户沟通需求，进行方案、前后端接口、关联系统交互接口的设计；",
              "3.编写功能代码和对应的测试代码，交付高质量（简洁清晰、易读易改）的代码，实现需求场景；",
              "4.修复用户使用中发现的程序bug，持续改进完善自己编写的模块的代码结构和质量，为自己编写的每一行代码负责；",
              "5.持续学习新的技术，持续提高软件设计能力；",
              "6.指导新员工。",
            ],
            representationrequirements: [
              "1.重点大学计算机相关专业本科以上学历，为人正直，好合作；",
              "2.6年以上大型ICT后端系统开发经验，3年以上Node.js开发经验；",
              "3.熟悉一般web应用系统的服务器端系统架构，熟悉mongoDB和redis的编程接口；",
              "4.熟悉HTTP、socket.io、TLS等常用协议，熟练掌握socket编程；",
              "5.熟练使用linux系统、Git和Docker；",
              "6.善于学习，乐于钻研，自我驱动。",
            ],
            bonus: [
              "1.有Kubernetes生产系统应用经验优先；",
              "2.有实时音视频通信系统开发经验优先，有webRTC或SIP应用开发经验优先+；",
              "3.有go编程经验优先，有Erlang编程经验优先+；",
              "4.有C++开发经验优先。",
            ],
          },
          {
            job: "资深媒体处理工程师",
            jobresponsibility: [
              "1.深度参与媒体服务器后端系统开发；",
              "2.负责媒体服务器音视频媒体处理（混音混流、转码）子系统的设计和开发；",
              "3.编写功能代码和对应的测试代码，交付高质量（简洁清晰、易读易改）的代码，实现需求场景；",
              "4.修复用户使用中发现的程序bug，持续改进完善自己编写的模块的代码结构和质量，为自己编写的每一行代码负责；",
              "5.持续学习新的技术，持续提高软件设计能力。",
            ],
            representationrequirements: [
              "1.重点大学计算机相关专业本科以上学历，为人正直，好合作；",
              "2.6年以上音视频处理系统开发经验，熟悉各种音视频编解码体系和算法；",
              "3.熟练使用C/C++编程，有良好的编程习惯，代码有品位；",
              "4.有良好的软件设计意识，持续学习软件复杂性管理的各种方法；",
              "5.熟悉Ffmpeg架构和API；",
              "6.善于学习，乐于钻研，自我驱动。",
            ],
            bonus: ["1.Ffmpeg开源项目贡献者优先；", "2. 有RTC系统开发经验者优先。"],
          },
          {
            job: "SIP协议高级开发工程师",
            jobresponsibility: [
              "1.深度参与媒体服务器后端系统开发；",
              "2.负责媒体服务器SIP接入相关子系统的设计和开发；",
              "3.编写功能代码和对应的测试代码，交付高质量（简洁清晰、易读易改）的代码，实现需求场景；",
              "4.修复用户使用中发现的程序bug，持续改进完善自己编写的模块的代码结构和质量，为自己编写的每一行代码负责；",
              "5.持续学习新的技术，持续提高软件设计能力。",
            ],
            representationrequirements: [
              "1. 重点大学计算机、通信相关专业本科以上学历，为人正直，好合作；",
              "2. 5年以上实时通信后端系统开发经验，熟悉SIP协议、SIP网络各部件职责；",
              "3. 熟练使用C/C++编程，有良好的编程习惯，代码有品位；",
              "4. 有良好的软件设计意识，持续学习软件复杂性管理的各种方法；",
              "5. 熟练使用linux系统、Git和Docker；",
              "6. 善于学习，乐于钻研，自我驱动。",
            ],
            bonus: [
              "1. 有开源SIP协议开源项目开发维护经验者优先；",
              "2. 有go/Erlang编程经验者优先；",
              "3. 有音视频系统开发经验者优先。",
            ],
          },
          {
            job: "后端架构工程师",
            jobresponsibility: [
              "1.深度参与媒体服务器后端系统开发；",
              "2.负责媒体服务器微服务总线、RPC、日志、消息中间件、存储中间件等基础架构系统的设计和开发；",
              "3.负责媒体服务器会话控制子系统的设计和开发；",
              "4.编写功能代码和对应的测试代码，交付高质量（简洁清晰、易读易改）的代码，实现需求场景；",
              "5.修复用户使用中发现的程序bug，持续改进完善自己编写的模块的代码结构和质量，为自己编写的每一行代码负责；",
              "6.持续学习新的技术，持续提高软件设计能力；",
              "7.指导新员工。",
            ],
            representationrequirements: [
              "1.重点大学计算机、通信相关专业本科以上学历，为人正直，好合作；",
              "2.10年以上ICT系统开发经验，有主导大规模分布式实时通信系统的开发工作的经验；",
              "3.有明确的技术成长路线，善于总结积累；",
              "4.擅长用软件设计的方法管理软件系统的复杂性；",
              "5.对系统可靠性设计有深刻的认识和丰富的实践；",
              "6.一直编程，作风务实；",
              "7.善于学习，乐于钻研，自我驱动。",
            ],
            bonus: ["1.媒体服务器开源项目参与者优先；", "2.有实时视频直播系统架构经验者优先。"],
          },
          {
            job: "高级后端协议开发工程师",
            jobresponsibility: [
              "1.深度参与媒体服务器后端系统开发；",
              "2.负责媒体服务器媒体接入（WebRTC/RTSP/RTMP）子系统的设计和开发；",
              "3.编写功能代码和对应的测试代码，交付高质量（简洁清晰、易读易改）的代码，实现需求场景；",
              "4.修复用户使用中发现的程序bug，持续改进完善自己编写的模块的代码结构和质量，为自己编写的每一行代码负责；",
              "5.持续学习新的技术，持续提高软件设计能力。",
            ],
            representationrequirements: [
              "1.重点大学计算机、通信相关专业本科以上学历，为人正直，好合作；",
              "2.5年以上RTC系统开发经验，熟悉Chromium WebRTC项目代码；",
              "3.熟悉SDP、ICE、DTLS/SRTP、RTSP/RTMP/HLS协议；",
              "4.熟练使用C/C++编程，有良好的编程习惯，代码有品位；",
              "5.有良好的软件设计意识，持续学习软件复杂性管理的各种方法；",
              "6.熟练使用linux系统、Git和Docker；",
              "7.善于学习，乐于钻研，自我驱动。",
            ],
            bonus: ["1.有webrtc媒体服务器开源项目参与者优先；", "2.有视频直播系统服务端开发经验者优先。"],
          },
        ],
        testDevelops: [
          {
            job: "高级测试工程师（音视频/RTC平台）",
            jobresponsibility: [
              "1.参与应用产品团队需求场景沟通；",
              "2.根据场景需求和项目开发迭代计划，编写对应的功能和非功能测试计划、测试用例；",
              "3.搭建测试环境，执行系统测试，出现BUG后协助开发团队进行初步定位，提供清晰明确的故障描述；",
              "4.研发团队修复BUG后进行回归验证；",
              "5.设计并搭建自动化CI/CD平台，持续改进产品交付过程。",
            ],
            representationrequirements: [
              "1.重点大学本科以上学历，5年以上软件测试实际工作经验；",
              "2.熟悉前后端软件系统测试流程，能够独立完成测试计划制定、测试用例设计；",
              "3.熟悉linux工作环境和常用命令，熟悉shell脚本编程；",
              "4.熟悉MySQL、MongoDB等常用数据库的检索和维护操作；",
              "5.熟悉网络协议，熟练使用wireshark等网络工具进行报文分析；",
              "6.熟悉Jenkins框架，有大型软件系统CI/CD平台搭建和维护经验；",
              "7.勤于实践，不断改进QA和测试工作；",
              "8.善于学习，乐于钻研，自我驱动。",
            ],
            bonus: ["1. 有金融行业系统和终端产品QA工作经验者优先；", "2. 有音视频系统QA工作经验者优先。"],
          },
          {
            job: "高级测试工程师（音视频/RTC应用）",
            jobresponsibility: [
              "1.参与平台产品需求场景沟通；",
              "2.根据场景需求和项目开发迭代计划，编写对应的功能和非功能测试计划、测试用例；",
              "3.搭建测试环境，执行系统测试，出现BUG后协助开发团队进行初步定位，提供清晰明确的故障描述；",
              "4.研发团队修复BUG后进行回归验证；",
              "5.设计并执行音视频各项客观技术指标的测试，为平台产品的音视频QoE提升提供数据；",
              "6.设计并执行各种部署方案下系统的压力测试；",
              "7.设计并搭建自动化CI/CD平台，持续改进产品交付过程。",
            ],
            representationrequirements: [
              "1.重点大学本科以上学历，5年以上软件测试实际工作经验；",
              "2.熟悉前后端软件系统测试流程，能够独立完成测试计划制定、测试用例设计；",
              "3.熟悉linux工作环境和常用命令，熟悉shell脚本编程；",
              "4.熟悉MySQL、MongoDB等常用数据库的检索和维护操作；",
              "5.熟悉网络协议，熟练使用wireshark等网络工具进行报文分析；",
              "6.熟悉Jenkins框架，有大型软件系统CI/CD平台搭建和维护经验；",
              "7.勤于实践，不断改进QA和测试工作；",
              "8.善于学习，乐于钻研，自我驱动。",
            ],
            bonus: [
              "1. 有WebRTC或其他实时通信系统QA和测试经验者优先；",
              "2. 有WebRTC前/后端开发经验，能够搭建demo系统者优先。",
            ],
          },
          {
            job: "技术支持工程师",
            jobresponsibility: [
              "1. 负责公司产品的交付，安装；",
              "2. 与客户保持良好的关系，作为客户和公司之间沟通的桥梁；",
              "3. 维护公司产品，收集，分析产品相关缺陷；",
              "4. 参与公司产品QA或测试工作。",
            ],
            representationrequirements: [
              "1. 计算机相关专业本科以上学历；",
              "2. 熟悉linux环境，熟悉资源监控命令；",
              "3. 掌握一门编程语言；",
              "4. 熟悉基本的网络知识；",
              "5. 熟悉基本的SQL命令。",
            ],
            bonus: ["1. 工作或者学习中了解过docker；", "2. 了解webrtc，sip，音视频相关知识。"],
          },
        ],
        salePosts: [
          {
            job: "售前工程师",
            jobresponsibility: [
              "1.作为销售团队一员，向客户准确介绍我司产品；",
              "2.针对客户场景需求和部署环境需求，提供妥善的解决方案；",
              "3.挖掘用户需求，给产品团队提供有效反馈；",
              "4.参与公司产品QA或测试工作。",
            ],
            representationrequirements: [
              "1.计算机相关专业本科以上学历；",
              "2.3年以上售前技术支持工作经验；",
              "3.熟悉金融行业客户IT系统架构；",
              "4.善于沟通，思路清晰，自信稳重；",
              "5.有团队协作精神，可接受经常出差；",
              "6.有产品意识，商业意识。",
            ],
            bonus: [
              "1. 有金融行业IT系统售前技术支持经验者优先；",
              "2. 有金融行业IT系统开发或实时音视频系统开发经验者优先。",
            ],
          },
          {
            job: "大客户销售",
            jobresponsibility: [
              "1.开拓银行等金融行业客户；",
              "2.介绍公司产品和服务，采集客户核心需求，准确把握产品与客户需求匹配点；",
              "3.与团队协作完成客户商务谈判，促成落单，维护公司品牌和客情关系；",
              "4.建立需求池，完成销售指标和潜在客户积累；",
              "5.与公司产品团队配合，及时提供客户对产品改进迭代的反馈意见;",
              "6.传播公司品牌价值、市场价值、社会价值。",
            ],
            representationrequirements: [
              "1.工作态度：能积极主动开拓客户，有较强的自驱力；",
              "2.沟通能力：富亲和力，与人交流和商务沟通能力突出，能处理复杂的商务沟通；",
              "3.学习能力：善于学习，对新事物有好奇心，并广泛研究与销售相关的课题，对产品和技术有一定的理解；",
              "4.品格：诚实正直，积极向上，务实守正；",
              "5.经验：3年以上金融行业销售经验，To B软件销售；",
              "6.资源：有银行、证券、保险等金融行业客户资源优先，有呼叫中心、视频呼叫中心、数字人客户资源者优先。",
            ],
          },
        ],
      };
    },
    methods: {
      showPartialDevelopsDetails(index) {
        this.idx = index;
      },
      foldPartialDevelopsDetails() {
        this.idx = undefined;
      },
      showBackendDevelopsDetails(index) {
        this.imx = index;
      },
      foldBackendDevelopsDetails() {
        this.imx = undefined;
      },
      showTestDevelopsDetails(index) {
        this.itx = index;
      },
      foldTestDevelopsDetails() {
        this.itx = undefined;
      },
      showSalePostDetails(index) {
        this.isx = index;
      },
      foldSalePostDetails() {
        this.isx = undefined;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "./join.scss";

  .main {
    .title {
      @extend %title;
    }

    .post {
      margin-top: 30px;
      margin-bottom: 28px;
      margin-left: 18px;
      color: #333;
      font-size: 25px;
      font-weight: 600;
      text-align: left;
    }
  }

  .plus {
    margin-right: 24px;
    width: 15px;
    height: 15px;
  }

  .subtraction {
    margin-right: 24px;
    width: 15px;
    height: 3px;
  }

  .plus-box {
    margin-bottom: 16px;
    height: 80px;
    border-radius: 10px;
    background: #f5f5f7;

    @extend .flex-space-between;
  }

  .subtraction-box {
    margin-bottom: 16px;
    border-radius: 10px;
    background: #f5f5f7;
  }

  .box {
    height: 80px;

    @extend .flex-space-between;
  }

  .requirements {
    padding-bottom: 21px;
    padding-left: 18px;
    text-align: left;

    @include background("~assets/img/joinus/watermark.png", 100% 100%, 217px 174px);

    p {
      color: #000;
      font-size: 20px;
    }
  }

  .jobresponsibility {
    margin-bottom: 4px;
    padding-top: 34px;

    @extend .border-top;

    &::before {
      right: 24px;
    }
  }

  .representationrequirements {
    margin-top: 16px;
    margin-bottom: 4px;
  }

  .bonus {
    margin-top: 16px;
    margin-bottom: 4px;
  }

  .job-name {
    margin-left: 18px;
  }

  .job-name.bold {
    font-weight: bold;
  }

  @media screen and (max-width: 992px) {
    .main {
      .title {
        font-size: 30px;

        &::before,
        &::after {
          background: unset;
        }
      }

      .post {
        font-size: 20px;
        text-align: center;
      }
    }

    .requirements {
      p {
        font-size: 16px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .main {
      .title {
        font-size: 20px;
      }

      .post {
        font-size: 17px;
      }
    }

    .requirements {
      p {
        font-size: 13px;
      }
    }
  }
</style>
